import { NAVBAR_ICON_URL } from '@/constants';
import { Topbar, BackButton } from '@shared/ui/topbar';
import { ArticleContentSkeleton } from '@pages/issue/ui/loading';

import styles from './favorite.module.css';

/**
 * The route's own `pendingComponent` (`route-catalog.tsx`'s `favorite`
 * route), shown while this page's lazy chunk is still in flight -- before
 * `Favorite` itself has ever mounted. Without this, that window fell back
 * to `createTenantApp`'s generic `defaultPendingComponent` (`RoutePending`),
 * a template-agnostic gray-box skeleton with no real navbar, so the reader
 * saw a generic bar swap for the real, correctly-sized navbar the instant
 * `Favorite` mounted -- the same flash `pages/issue/ui/loading.tsx`'s
 * `Loading` and `pages/preview/ui/route-loading.tsx`'s
 * `PreviewRouteLoading` exist to avoid, same fix here.
 *
 * `BackButton` (via `useGoBack`) works with no article data at all, so it's
 * real and functional immediately -- `Favorite`'s own `Topbar` swaps it for
 * one bound to `onBack` (which also has to know which section to return to)
 * only once the page's context is available; same visual slot either side.
 *
 * `ArticleContentSkeleton` is the exact skeleton `Favorite`'s own
 * `LoadingView` renders once mounted (`favorite.tsx`) and the one
 * `/issues/:issueId/:articleId`'s `Loading` renders for its content area --
 * reusing it here means the route-pending skeleton and the component's own
 * post-mount loading skeleton are pixel-identical, so there's no second
 * visible swap once the chunk resolves and `isLoading` is still `true`.
 */
export function FavoriteRouteLoading() {
	return (
		<div className={styles['view']}>
			<Topbar
				className={styles['topbar']}
				left={<BackButton />}
				center={
					<div className={styles['title']}>
						<img src={NAVBAR_ICON_URL} alt="Logo" />
					</div>
				}
			/>
			<div className={styles['content']}>
				<ArticleContentSkeleton />
			</div>
		</div>
	);
}
